import { INGFile } from '@nickalie/ngb/models/INGFile';
import { ngb } from '@nickalie/ngb';
import { loading } from './LoadingService';
import { uuid } from '@nickalie/ngb/utils';

class FileService {
  private _input: HTMLInputElement | undefined;

  select(accept = '.png, .jpg, .jpeg'): Promise<INGFile> {
    if (this._input) {
      this._input.remove();
    }

    this._input = document.createElement('input');
    this._input.type = 'file';
    this._input.style.position = 'absolute';
    this._input.style.opacity = '0';
    this._input.style.pointerEvents = 'none';
    this._input.accept = accept;

    return new Promise<File>((resolve, reject) => {
      const handler = () => {
        this._input!.removeEventListener('change', handler);

        if (this._input!.files!.length === 0) {
          reject('nothing was selected');
          return;
        }

        resolve(this._input!.files![0]);
        this._input!.value = '';
      };

      this._input!.addEventListener('change', handler);
      this._input!.click();
    }).then(this.upload.bind(this));
  }

  private async upload(file: File): Promise<INGFile> {
    const ref = uuid() + file.name;
    return loading.wrap(ngb.storage.put(ref, file));
  }

  delete(ref: string): Promise<void> {
    return loading.wrap(ngb.storage.delete(ref));
  }
}

export const fileService: FileService = new FileService();
